import React from 'react';
import { GatsbyImage } from 'gatsby-plugin-image';
import TextAlignment from '../../../components/TextAlignment';
import getThemeClass from '../../../utils/getThemeClass';
import styles from './ImageTile.module.css';
import Cutouts from '../../../components/Cutouts';

/**
 * @param {FF.ContentfulImageTileProps} props
 * */
export default function ImageTile({
  alignment,
  backgroundColor,
  className = '',
  cutouts,
  edgeToEdgeImage,
  image,
}) {
  const imageProps = {
    alt: image.description,
    image: image.gatsbyImageData,
  };
  if (edgeToEdgeImage) {
    Object.assign(imageProps, {
      className: styles.windowedImage,
      placeholderClassName: styles.windowedImage,
    });
  }

  return (
    <Cutouts cutouts={cutouts} noPadding>
      <TextAlignment
        alignment={edgeToEdgeImage ? 'Center' : alignment}
        className={`${getThemeClass(backgroundColor)} ${className}`}
      >
        <GatsbyImage {...imageProps} loading="lazy" />
      </TextAlignment>
    </Cutouts>
  );
}
